// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__bN_sF","footerColumns":"footer_footerColumns__fz2ch","footerColumnsGrid":"footer_footerColumnsGrid__rqF_g","footerIcons":"footer_footerIcons__KswcW"};